import type {Pinia} from 'pinia';
import {appContextOptions} from '../appContextOptions';
import {createFetchContext} from './fetchContext';

export function createLoadApiContext(appId: string) {
    /** Fetch the `self` entry to get the base app context, and store it in the Pinia store */
    async function loadApiContext(_pinia: Pinia, _testing = false): Promise<void> {
        appContextOptions.updatePiniaInstance(_pinia, _testing);

        const fetchContext = createFetchContext(appId);

        const {useAppContext} = appContextOptions.instances.get(appId)!;
        if (_testing) {
            return;
        }
        const appContext = useAppContext(_pinia);
        appContext.loading = true;

        try {
            await fetchContext();
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        } finally {
            appContext.loading = false;
        }
    }

    return loadApiContext;
}
